module.exports = __webpack_public_path__ + "img/season.7466df6e.png";